import { TabItem } from "@appretio/ui-kit";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useSheetTabs(tabs: TabItem[]) {
  const [searchParams, setSearchParams] = useSearchParams();

  const { activeTab, activeTabValue, defaultTabValue } = useMemo(() => {
    const defaultTab = tabs[0];
    const tabFromSearchParam = searchParams.get("tab") ?? "";

    const foundTab = tabs.find((tab) => tab.value === tabFromSearchParam);
    const activeTab = foundTab ?? defaultTab;
    return {
      defaultTab,
      defaultTabValue: defaultTab.value,
      activeTab,
      activeTabValue: activeTab.value
    };
  }, [searchParams, tabs]);

  const handleTabChange = useCallback(
    (next: string) => {
      if (next === activeTabValue) {
        return;
      }
      setSearchParams(
        (prev) => {
          const nextParams = new URLSearchParams(prev);
          if (next === defaultTabValue) {
            nextParams.delete("tab");
          } else {
            nextParams.set("tab", next);
          }
          return nextParams;
        },
        { replace: true }
      );
    },
    [activeTabValue, defaultTabValue, setSearchParams]
  );

  return { activeTab, handleTabChange };
}
